import React from 'react';
import { NavLink } from 'react-router-dom';
import { useStyles } from './styles';
export var WholePageFormHelperNavLink = function (_a) {
    var _b = _a.linkText, linkText = _b === void 0 ? '' : _b, _c = _a.navPath, navPath = _c === void 0 ? '' : _c, id = _a.id;
    var classes = useStyles();
    return (React.createElement(NavLink, { id: id, className: classes.textForPassword, to: navPath }, linkText));
};
